export default __webpack_public_path__ + "static/media/UTPL-Financials-2021.43bf77f7.pdf";